import { put } from "redux-saga/effects";

import { SET_FLAG } from "../CONSTANTS";

export default function* onAppReady() {
  yield put({
    type: SET_FLAG,
    payload: { key: "permissionsClarified", value: true },
  });
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/onSessionRejected.js